import { environment as currentEnvironment } from "../../../environments/environment";


export function isGeneral2(){
  return currentEnvironment.instanceType == 'general2'
}


export function isBeta( ){
  return currentEnvironment.production === false 
}

export function isNonCandidateApp(environment) {
    return environment.instanceType === 'general' || environment.instanceType === 'lawlite' || environment.instanceType === 'generallite' || environment.instanceType === 'education';
}

export function isLaw(environment) {
    return environment.instanceType === 'law' || environment.instanceType === 'lawlite';
}

export function isEducation(environment) {
  return environment.instanceType === 'education';
}
